import React from "react";
import { EditAgentGuardContext } from "./editAgentGuard.context";
import { ConfirmationModal } from "./components/confirmationModal/confirmationModal.index";
import { MainDetails } from "./components/mainDetails/mainDetails.index";
import { useAgentDetails } from "./hooks/useAgentDetails";
import { useUnsavedChangesGuard } from "./hooks/useUnsavedChangesGuard";
import styles from "./editAgent.module.css";

const EditAgent = () => {
    const { data, loading } = useAgentDetails();
    const {
        guardNavigation,
        isModalOpen,
        isSaving,
        hasErrors,
        canSave,
        handleModalCancel,
        handleModalSave,
    } = useUnsavedChangesGuard();

    if (loading) return null;
    if (!data) return null;

    return (
        <EditAgentGuardContext.Provider value={guardNavigation}>
            <div className={styles.container}>
                <MainDetails guardNavigation={guardNavigation} isSaving={isSaving} />
                <ConfirmationModal
                    open={isModalOpen}
                    saving={isSaving}
                    onCancel={handleModalCancel}
                    onSave={handleModalSave}
                    confirmDisabled={!canSave}
                    message={
                        hasErrors
                            ? "You have unsaved changes, but some fields contain errors. Fix them before saving and continuing."
                            : "You have unsaved changes. Save your changes before continuing."
                    }
                    confirmButtonText="Save"
                />
            </div>
        </EditAgentGuardContext.Provider>
    );
};

export default EditAgent;
